import { render } from "./ExpansionPanel.vue?vue&type=template&id=7be61566&scoped=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts"

import "./ExpansionPanel.vue?vue&type=style&index=0&id=7be61566&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7be61566"

export default script